import React from "react";
import styles from "./Edit.module.scss";
import "./Task.css";
import { connect } from "react-redux";
import Select, { components } from "react-select";
import DatePicker from "react-datepicker";
import { Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import horizontal from "../../Components/icons/trajectory.svg";
import trackterImage from "../../Components/Tracktor/tracktor.png";
import calen from "../../Components/icons/calender.svg";
import vertical from "../../Components/icons/horizontal.svg";
import idea from "../../Components/Implement/idea.svg";
import edit from "../../Components/icons/edit.svg";
import disk_narrow from "./disk_narrow.png";
import power_bidder from "./power_bidder.png"
import rotary_tiller from "./rotary_tiller.png"
import sieve from "./sieve.png"
import * as Action from "../../Store/Action";
class EditTask  extends React.Component {
    state = {
        taskname:""
    }
    onChangeName = (name) =>{   
           this.setState({
               taskname:name.target.value
           })
    }
    componentDidMount = ()=>{
        const datePickers = document.getElementsByClassName(
            "react-datepicker__input-container"
          );
          for (let i = 0; i < datePickers.length; i++) {
            datePickers[i].childNodes[0].setAttribute("readonly", true);
          }
    }

    submit = (index)=>{
       if(this.state.taskname !== ""){
           this.props.updateTask(index,this.state.taskname)
           this.props.history.goBack()
       }
    }
    render() {
        var result = {}
        const implSrc = {
            "Disk Narrow": disk_narrow,
            "Rotary Tiller": rotary_tiller,
            "Power Bedder":power_bidder ,
            "Sieve":sieve 
        }
        const index = this.props.match.params.index
        if(index){
            const i = Number(index)
            result = this.props.tasks[i];
            if(!result){
                this.props.history.push("/tasks")
            }
        }else{
            this.props.history.push("/tasks")
        }
        const { Option } = components
        const CustomSelectOption = props => (
            <Option  {...props}>
              <img className="mr-2" src={props.label === "Horizontal"? horizontal:vertical} alt={props.label}></img>
              <span style={{
                   fontSize:"14px",
                   fontWeight:"500"
              }}> {props.data.label}</span>
            </Option>
          )
          const CustomSelectValue = props => (
            <div style={{
                background:"none",
                fontSize:"14px",
                fontWeight:"500"
            }}>
              {props.data.label}
            </div>
          )     
          const CCustomSelectOption = props => (
            <Option  {...props}>
             <div style={{
                fontSize:"7px",
                display:"flex",
                alignItems:"center",
                  
            }}>
            <span> <i style={{
                 color:props.data.color
            }}  class="fas fa-circle"></i></span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"700"
              }}>&nbsp; {props.data.label} </span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"400"
              }}>&nbsp; | {props.data.acre} acre</span>
            </div>
            </Option>
          )
          const CCustomSelectValue = props => (
           
            <div style={{
                fontSize:"7px",
                display:"flex",
                alignItems:"center",
                  
            }}>
       <span> <i style={{
                 color:props.data.color
            }}  class="fas fa-circle"></i></span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"700"
              }}>&nbsp; {props.data.label} </span>
              <span style={{
                  fontSize:"14px",
                  fontWeight:"400"
              }}>&nbsp; | {props.data.acre} acre</span>
            </div>
          )              

        const zd = this.props.zones[result["zindex"]]
        const pd = zd.plots[result["pindex"]]
        const cd = pd.cropsland[result["cindex"]]
        const zone = {value:zd.name,label:zd.name,color:zd.strokeColor,acre:zd.acre}
        const plots = {value:pd.name,label:pd.name,color:pd.strokeColor,acre:pd.acre}
        const croplands = {value: cd.name,acre:cd.acre,color:cd.pinColor,label:cd.name}
        const curvedStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                background:"white",
                fontSize:"14px",
                fontWeight:"500",
                color:"#081C48"
            })

        }
        const trajectoryStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                paddingLeft: "40px",
                backgroundColor: "transparent",
                fontSize:"14px",
                fontWeight:"500",
                color:"#081C48"
            }),
            IndicatorSeparator: () => null,
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isDisabled
                    ? null
                    : isSelected
                    ? data.color
                    : isFocused
                    ? "white"
                    : null,
                  color: isDisabled
                    ? '#ccc'
                    : isSelected
                    ? "white" > 2
                      ? 'white'
                      : 'black'
                    : data.color,
                  cursor: isDisabled ? 'not-allowed' : 'default',
            
                  ':active': {
                    ...styles[':active'],
                    backgroundColor:
                      !isDisabled && (isSelected ? data.color : "white"),
                  },
                };
              },
        }
        const implementRender =<div>
        <div className="d-flex justify-content-between">
            <p style={{
                fontWeight: "500",
                fontSize: "18px",
                color: "#081C48"
            }}>{result["implementName"]}</p>
           <img src={idea} alt="idea"></img>
        </div>
        <img width="100%" src={implSrc[result["implementName"]]} alt="implement"></img>
    </div>
        const trajectoryIcon = result["trajectory"] === "horizontal" ? horizontal : vertical
        const tracktorRender = <div>
            <div className="d-flex justify-content-between">
                <p style={{
                    fontWeight: "500",
                    fontSize: "18px",
                    color: "#081C48"
                }}>{result["tracktername"]}</p>
                <div className="d-flex align-items-center">
                    <small style={{
                        color: result["batteryColor"]
                    }}>80%</small>
                    <div className="d-flex ml-1">
                        <div style={{
                            height: "15px",
                            width: "6px",
                            background: result["batteryColor"]
                        }} className="rounded"></div>
                        <div style={{
                            height: "15px",
                            width: "6px",
                            marginLeft: "2px",
                            background: result["batteryColor"]
                        }} className="rounded"></div>
                        <div style={{
                            height: "15px",
                            width: "6px",
                            marginLeft: "2px",
                            background:result["batteryColor"]
                        }} className="rounded"></div>
                        <div style={{
                            height: "15px",
                            width: "6px",
                            marginLeft: "2px",
                            background:result["batteryColor"]
                        }} className="rounded"></div>
                        <div style={{
                            height: "15px",
                            width: "6px",
                            marginLeft: "2px",
                            background: result["batteryColor"],
                            opacity: "0.3"
                        }} className="rounded"></div>
                    </div>
                </div>
            </div>
            <img width="100%" src={trackterImage} alt="tracktor"></img>
        </div>
        return (
           <div className={styles.task_container}>
                <div style={{
                    cursor: "pointer"
                }} onClick={() => {
                    this.props.history.goBack()
                }} className="d-flex text-muted">
                    <p style={{
                         fontSize: "14px",
                         fontWeight: "500",
                    }}><i class="fa fa-chevron-left"></i> </p>
                    <p className={styles.back_button_text}>Back</p>
                </div>
                <Row style={{
                    marginTop:"2rem"
                }} className="align-items-center mt-4">
                    <Col md={9}>
                        <input ref={ref=>this.taskinput=ref}   defaultValue={result["taskname"]} onChange={this.onChangeName} className={`form-control border-0 ${this.state.taskname? '':""}`} style={{
                            fontWeight: 500,
                            fontSize: "23px",
                            lineHeight: "27px",
                            color: "#081C48"
                        }} placeholder="New Task"></input>
                    </Col>
                    <Col md={3}>
                        <img onClick={()=>{
                            this.taskinput.focus()
                        }} src={edit} alt="edit"></img>
                    </Col>
                </Row>
                <div style={{ marginTop: "28px" }}>
                    <p className={`${this.state.cropland?"text-muted":"text-muted"} mb-2`} style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>Zone</p>
                    <Select  isDisabled={true}  isSearchable={false} components={{ Option: CCustomSelectOption, SingleValue: CCustomSelectValue,IndicatorSeparator: () => null }} 
                 styles={curvedStyle} defaultValue={zone}></Select>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className={`${this.state.cropland?"text-muted":"text-muted"} mb-2`} style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>Plot</p>
                    <Select  defaultValue={plots} isDisabled={true}  isSearchable={false} components={{ Option: CCustomSelectOption, SingleValue: CCustomSelectValue,IndicatorSeparator: () => null }} 
                 styles={curvedStyle}  onChange={(info) => {
                  
                    this.setState({
                        pindex:info.index,
                        cropland:null
                    },()=>{
                        this.selectCrop.select.clearValue(); 
                    })
                 }}></Select>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className={`${this.state.cropland?"text-muted":"text-muted"} mb-2`} style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>Cropland</p>
                    <Select defaultValue={croplands} isDisabled={true} isSearchable={false} components={{ Option: CCustomSelectOption, SingleValue: CCustomSelectValue,IndicatorSeparator: () => null }} 
                 styles={curvedStyle} onChange={this.handleChange}></Select>
                </div>
                <div   style={{ marginTop: "28px" }}>
                    <p className={`${this.props.name?"text-muted":"text-muted"} mb-2`}  style={{
                         fontSize: "12px",
                         fontWeight:"400",
                         paddingLeft: "10px"
                    }}>Tractor</p>
                    <div className="text-center" 
                    style={{borderRadius:"15px",border:"1px solid #EBEDF0",padding: "12px"  }}>
                        {tracktorRender}

                    </div>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className={`${this.props.implementName?"text-muted":"text-muted"} mb-2`}  style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>Implement</p>
                    <div className="text-center" style={{borderRadius:"15px",border:"1px solid #EBEDF0", padding: "12px"  }}>
                           {implementRender}
                    </div>
                </div>
                <div className={styles.pos_rel} style={{ marginTop: "28px" }}>
                    <p className={`${this.state.trajectory?"text-muted":"text-muted"} mb-2`}  style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>Trajectory</p>
                    <img src={trajectoryIcon} className={styles.trajectory_img} alt="tri_icon" />
                    <Select isDisabled={true}  isSearchable={false}  components={{ Option: CustomSelectOption, SingleValue: CustomSelectValue,IndicatorSeparator: () => null }} styles={trajectoryStyle} defaultValue={{name:result["trajectory"],label:result["trajectory"]}}  ></Select>
                </div>
                <div style={{ marginTop: "28px" }}>
                    <p className="text-muted mb-2" style={{
                        fontSize: "12px",
                        fontWeight:"400",
                        paddingLeft: "10px"
                    }}>
                        Track Width
                     </p>
                    <div className="d-flex justify-content-between">
                        <div  style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0.5rem",
                            border: "1px solid #eee",
                            borderRadius: "200px"
                        }}>
                            <i  style={{ color: "grey" }} class="fas fa-minus"></i>
                        </div>
                        <p className="text-muted">3400 M</p>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0.5rem",
                            border: "1px solid #eee",
                            borderRadius: "100px"
                        }}>
                            <i   style={{ color: "grey" }} class="fas fa-plus"></i>
                        </div>
                    </div>
                    <div style={{ marginTop: "28px" }}>
                        <p className={`${this.state.schedule?"text-muted":"text-muted"} mb-2`}  style={{
                            fontSize: "12px",
                            fontWeight:"400",
                            paddingLeft: "10px"
                        }}>Schedule</p>
                        <div className={styles.pos_rel}>
                            <img width="100%"  src={calen} className={styles.calendar_img} alt="calendar_icon" />
                            <DatePicker minDate={new Date()}  className="datepicker" disabled={true}  value={result["schedule"]} selected={new Date()}></DatePicker>
                        </div>
                    </div>
                    <div style={{ marginTop: "28px" }}>
                        <p className="text-muted mb-2" style={{
                            fontSize: "12px",
                            fontWeight:"400",
                            paddingLeft: "10px"
                        }}>Approx Completion Time</p>
                        <div >
                            <p className="text-muted mb-2" style={{ fontWeight: "bold", paddingLeft: "10px" }}>
                                2 hrs
                            </p>
                        </div>
                        <div>
                        </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <button onClick={()=>this.submit(Number(index))} className={"blue_button mt-4"}>
                           Update Task
                     </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        zones: state.zones,
        tasks:state.tasks
    }
}

const mapDispatchToProps = dispatch =>{
    return {
        updateTask:(index,name)=>dispatch({type:Action.UPDATE_TASK,name,index})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTask)